import { render, staticRenderFns } from "./AdminBulkUpdateLessonFormCard.vue?vue&type=template&id=4cea0f86&scoped=true&"
import script from "./AdminBulkUpdateLessonFormCard.vue?vue&type=script&lang=js&"
export * from "./AdminBulkUpdateLessonFormCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminBulkUpdateLessonFormCard.vue?vue&type=style&index=0&id=4cea0f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cea0f86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
